import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';
import ArticleCard from '@/components/feature/ArticleCard';

export default function LatestFeed() {
  const sorted = [...articles].sort((a, b) => (a.date < b.date ? 1 : -1));
  const featured = sorted[0];
  const rest = sorted.slice(1, 7);

  return (
    <section className="bg-background-100/70 border-y border-background-200" id="latest">
      <div className="mx-auto max-w-content px-4 md:px-8 py-14 md:py-20">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8 md:mb-10">
          <div>
            <p className="text-xs tracking-[0.3em] text-primary-600 font-label">ARCHIVE</p>
            <h2 className="mt-3 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              最新反差档案
            </h2>
            <p className="mt-2 text-sm text-foreground-600 max-w-xl">
              按时间倒序整理的现场记录，每一篇都保留完整语境，不做掐头去尾的处理。
            </p>
          </div>
          <Link
            to="/category/offstage"
            className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 font-label whitespace-nowrap"
          >
            浏览更多
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        {featured && (
          <div className="mb-6">
            <ArticleCard article={featured} variant="wide" />
          </div>
        )}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {rest.map((article) => (
            <ArticleCard key={article.id} article={article} />
          ))}
        </div>
      </div>
    </section>
  );
}